<template>
	<div class="ConfirmPrompt_template" @click="CancelFun()">
		<div class="ConfirmPrompt_box" @click="CancelFun()">
			<div class="header_icon">
				<div class="el-icon-close" @click="CancelFun()"></div>
			</div>
			<div class="ConfirmPrompt">
				<div class="content_box">
					{{ $t('ConfirmPrompt.delete_tips') }} {{ titlePrompt }}
				</div>
				<div class="btn_box">
					<div class="btn CancelFun" @click="CancelFun()">{{ $t('buttonArr.Cancel') }}</div>
					<div class="btn ConfirmFun" @click="ConfirmFun()">{{ $t('buttonArr.Confirm') }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ConfirmPrompt',

	props: {
		Loading: {
			type: Boolean,
			default: false,
		},
		titlePrompt: {
			type: String,
			default: ""
		},
	},
	data() {
		return {
			no_data_text: ""
		}
	},
	
	// 监听
	watch: {
		// "Post_List": {
		// 	handler: function (newValue, oldValue) {
		// 		this.list = this.Post_List
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
		
	},
  
	methods:{
		ConfirmFun(){
			this.$emit('ConfirmFun')
		},
		
		CancelFun(){
			this.$emit('CancelFun')
		}
	}
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.ConfirmPrompt_template{
		position: fixed;
		z-index: 999;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.2);
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #999;
		padding: 10px 10px;
		font-size: 14px;
	}
	.ConfirmPrompt_box{
		width: 100%;
		max-width: 400px;
		background-color: #ffffff;
		padding: 10px 10px 20px 10px;
		border-radius: 8px;
	}
	.header_icon{
		display: flex;
		justify-content: flex-end;
	}
	.el-icon-close{
		font-size: 24px;
		cursor: pointer;
		color: #999999;
	}
	.ConfirmPrompt{
		padding: 5px 5px;
	}
	.content_box{
		font-size: 16px;
		color: #333333;
		min-height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.btn_box{
		width: 100%;
		margin-top: 20px;
		display: flex;
		.btn{
			text-align: center;
			padding: 10px 10px;
			width: calc(50% - 5px);
			font-size: 14px;
			border-radius: 20px;
			cursor: pointer;
			line-height: 1;
		}
		.CancelFun{
			color: #06f;
			border: 1px #06f solid;
			// color: #2094FA;
			// border: 1px #2094FA solid;
			background-color: #ffffff;
		}
		.ConfirmFun{
			margin-left: 10px;
			color: #ffffff;
			border: 1px #06f solid;
			background-color: #06f;
			// border: 1px #2094FA solid;
			// background-color: #2094FA;
		}
	}
	@media screen and (min-width: 1024px) {
		
	}
	@media screen and (max-width: 1024px) {
		
	}
</style>
